import type React from "react";

import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import type { CustomStatus, FlowType } from "routes/login/queries/authenticateWithBankid";
import { translateStatus } from "routes/login/utils/translateStatus";
import { BaseButton } from "shared/atoms/BaseButton";

import { LoginContainer } from "../components/LoginContainer";
import { LoginInfoContainer } from "../components/LoginInfoContainer";
import { Container, LoginWrapper } from "../components/styledComponents";

interface CustomizedState {
  error: CustomStatus;
  flowType: FlowType;
}

export const ResultFailed: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as CustomizedState;

  return (
    <LoginWrapper>
      <LoginContainer>
        <LoginInfoContainer title={t("login.bankid.title")} />
        <Container>
          <Error>{translateStatus({ flowType: state?.flowType, status: state?.error })}</Error>
          <Stack spacing={1} width="100%">
            <BaseButton id="bankid-try-again" data-testid="bankid-try-again" onClick={() => navigate(-1)} fullWidth>
              {t("buttons.retry")}
            </BaseButton>
            <BaseButton
              variant="text"
              id="bankid-cancel"
              data-testid="bankid-cancel"
              onClick={() => navigate("/login/bankid")}
              fullWidth
            >
              {t("buttons.cancel")}
            </BaseButton>
          </Stack>
        </Container>
      </LoginContainer>
    </LoginWrapper>
  );
};

const Error = styled.div`
  margin-bottom: 24px;
`;
